import { render, staticRenderFns } from "./Contato.vue?vue&type=template&id=7554b234&scoped=true"
import script from "./Contato.vue?vue&type=script&lang=js"
export * from "./Contato.vue?vue&type=script&lang=js"
import style0 from "./Contato.vue?vue&type=style&index=0&id=7554b234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7554b234",
  null
  
)

export default component.exports